import React from "react"
import SEO from "../../components/shared/seo"
import Hero from "../../components/shared/hero"
import useHeroSmokeImages from "../../components/map-management/useHeroImages"
import { HeroOverlay } from "../../components/map-management/hero.style"
import HeroDescription from "../../components/map-management/hero-description"
import MappedinLayers from "../../components/shared/platform-layers-v2"
import CMSFunctions from "../../components/map-management/cms-functions"
import VenueData from "../../components/map-management/venue-data"
import ApplicationsDiagram from "../../components/map-management/applications-diagram"
import Layout from "../../components/shared/layout"
import useLayerImages from "../../components/map-management/useLayerImages"
import Footer from "../../components/shared/footer"
import Contact from "../../components/shared/contact"
import MapsShowcaseSection from "../../components/map-management/maps-showcase"
import BlogFeatures from "../../components/map-management/blog-features"
import FAQ from "../../components/map-management/faq"

export default function IndoorMappingPage({ location }) {
  const layerAssets = useLayerImages()
  const images = useHeroSmokeImages()
  return (
    <Layout location={location}>
      <SEO
        title="Indoor Mapping Software with Navigation & Positioning"
        description="Mappedin’s office mapping software keeps your floor plans up-to-date, provides intuitive wayfinding to employees and visitors, and seamlessly integrates with other smart building technology. Contact us today!"
      />
      <Hero
        overlayStyle={HeroOverlay}
        title={"Indoor Mapping Software with Navigation & Positioning"}
        sizes={images}
      />
      <HeroDescription />
      <MappedinLayers overlayLayer={1} assets={layerAssets} />
      <CMSFunctions />
      <VenueData />
      <MapsShowcaseSection />
      <ApplicationsDiagram />
      <BlogFeatures />
      <FAQ />
      <Contact />
      <Footer />
    </Layout>
  )
}
